module.exports = __webpack_public_path__ + "static/media/products2.c2a1c5a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/products2.jpg
// module id = 717
// module chunks = 0